import { NavLink as NavLinkComponent } from 'react-router-dom';
import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import apLogoShort from '../../../assets/images/ap-logo-short.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderWrapper = styled.div`
  position: relative;
`;

export const NavLink = styled(NavLinkComponent)`
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin: 0 4px;
  font-size: 16px;
  font-weight: 400;
  color: ${colors.grey300};
  transition: color 100ms ease-out;
  white-space: nowrap;
  text-decoration: none;
  height: 46px;
  line-height: 46px;
  border-bottom: 2px solid transparent;

  &.active {
    color: ${colors.white};
    font-weight: 500;
    border-bottom: 2px solid ${colors.grey200};
  }
`;

export const Logo = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  &::before {
    background: url(${apLogoShort}) no-repeat center;
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.white};
  font-weight: 500;
  font-size: 19px;
  line-height: 24px;

  & + div {
    display: none;
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: 24px;
  margin: 0 8px 0 6px;
  background-color: ${colors.white};
`;
